@if (userService.isServiceProvider) {
  <app-rollups-gcline-items-sidebar></app-rollups-gcline-items-sidebar>
} @else {
  <app-rollups-manager-sidebar></app-rollups-manager-sidebar>
}
